module.exports = __webpack_public_path__ + "static/sub-nav-hover-4a2c63f9aaf89aa9c21fc636a212e642.png";